module.exports = __webpack_public_path__ + "img/design_manager.13dea3b4.jpg";